import { FC, ComponentProps } from 'react';
import { Text } from '@bpba/ui-components';
import { ProductoData } from '../../model/ProductoData';
import { NumberFormat } from '../../config/NumberFormat';

type Props = {
  product?: ProductoData;
  legend?: string;
} & ComponentProps<typeof Text>;

export const PointsComponent: FC<Props> = (props) => {
  const { product, legend, ...otherProps } = props;

  if (product?.puntos == null) return <></>;

  return (
    <Text fontWeight="bold" marginTop="0px" color="primary.0" {...otherProps}>
      {NumberFormat.formatNumber(product.puntos)}
      {legend ? ` ${legend}` : ''}
    </Text>
  );
};
